import { render, staticRenderFns } from "./ProductWhiteList.vue?vue&type=template&id=5c73d047&"
import script from "./ProductWhiteList.vue?vue&type=script&lang=js&"
export * from "./ProductWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./ProductWhiteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports